import Button from '@sats-group/ui-lib/react/button';
import HiddenInput from '@sats-group/ui-lib/react/hidden-input';
import React from 'react';
import FlowLayout from '~/client/components/flow-layout/flow-layout';
import type { RenewPreview as Props } from './renew-preview.types';

const RenewPreview: React.FC<Props> = ({ debug, form, layout }) => (
  <FlowLayout {...layout}>
    <div className="renew-preview">
      {form ? (
        <form action={form.action} method="post">
          {form.data.map(entry => (
            <HiddenInput {...entry} key={entry.name} />
          ))}
          <Button {...form.submit} type="submit" />
        </form>
      ) : null}
      {debug ? (
        <code>
          <pre>{debug}</pre>
        </code>
      ) : null}
    </div>
  </FlowLayout>
);

export default RenewPreview;
